


















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { GetterNames } from '@/store/modules/patient/keys'
import { WatchStatusTypes } from '@/store/modules/watch-list/types'
import { PATIENT_STATS_PAGE_TYPES } from '@/utils/constants'
import { PATIENT_NOUN } from '@/constants/app-variables'

export default Vue.extend({
  props: {
    watchLists: {
      type: Array,
      default: () => [],
    },
    watchListLoadings: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      patientNoun: PATIENT_NOUN,
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, { patientNameById: GetterNames.patientNameMapById }),
  },
  methods: {
    // watchWatchList(watchListId) {
    //   this.$emit('watch-list:patch', {
    //     id: watchListId,
    //     watchStatus: WatchStatusTypes.MANUAL
    //   })
    // },
    unwatchWatchList(watchListId): void {
      this.$emit('watch-list:patch', {
        id: watchListId,
        watchStatus: WatchStatusTypes.UNWATCH,
      })
    },
  },
})
